module.exports = __webpack_public_path__ + "img/222.81d51e4b.png";